import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle, Trophy } from "lucide-react";

/** V1.80 · Avisa en la ficha cuando las tasas del alumno se quedan sin
 *  convocatorias (hay que renovar tasa) o cuando ya obtuvo el permiso. */
export default function TasaRenewalBanner({ studentId, refreshKey = 0 }) {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/students/${studentId}/tasas-unificadas`);
        if (cancelled) return;
        const rows = data || [];
        if (rows.length === 0) { setInfo(null); return; }
        const permit = rows.find((r) => r.state?.permit_obtained);
        const free = rows.find((r) => !r.id || !r.state?.exhausted);
        const last = rows.find((r) => r.state);
        setInfo({ permit: !!permit, exhausted: !free, number: last?.tasas_number || "" });
      } catch {
        if (!cancelled) setInfo(null);
      }
    })();
    return () => { cancelled = true; };
  }, [studentId, refreshKey]);

  if (!info) return null;
  if (info.permit) {
    return (
      <div
        data-testid="tasa-permit-banner"
        className="flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-900"
      >
        <Trophy className="h-4 w-4 shrink-0" />
        <span><b>Permiso obtenido</b> con la tasa <span className="font-mono">{info.number}</span>.</span>
      </div>
    );
  }
  if (!info.exhausted) return null;
  return (
    <div
      data-testid="tasa-renewal-banner"
      className="flex items-center gap-2 rounded-lg border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-900"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>
        <b>Renovar tasa</b> — la tasa <span className="font-mono">{info.number}</span> se ha quedado sin
        convocatorias. Añade una tasa nueva antes de volver a convocar a este alumno.
      </span>
    </div>
  );
}
